import React from "react";

const ScrollEndContext = React.createContext({
  scrollEnd: false,
  setScrollEnd: () => {},
});

export default ScrollEndContext;
